import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsFor } from '../components/WhoIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen w-full bg-brand-bg text-brand-text font-sans selection:bg-brand-gold/30 selection:text-brand-gold" data-id="element-149">
      <HeroSection data-id="element-150" />
      <ProblemSection data-id="element-151" />
      <MechanismSection data-id="element-152" />
      <WhatYouGet data-id="element-153" />
      <WhoIsFor data-id="element-154" />
      <HowItWorks data-id="element-155" />
      <ProofSection data-id="element-156" />
      <FAQSection data-id="element-157" />
      <OfferSection data-id="element-158" />

      <footer className="w-full py-8 text-center border-t border-brand-card bg-brand-bg" data-id="element-159">
        <p className="text-brand-faint text-sm" data-id="element-160">
          © {new Date().getFullYear()} El Método Sin-Tipster. Todos los
          derechos reservados.
        </p>
        <p className="text-brand-faint text-xs mt-2 max-w-2xl mx-auto px-4" data-id="element-161">
          Aviso legal: Las apuestas deportivas conllevan riesgo. Este material
          es estrictamente educativo y no constituye asesoramiento financiero.
          Juega con responsabilidad.
        </p>
      </footer>
    </main>;
}